
import { Component, Prop, Vue} from 'vue-property-decorator';

@Component

export default class ModalConfirm extends Vue {
    isActive = true
    @Prop({type: Boolean, default: false}) private isLoading?: boolean
    @Prop({type: String, default: ''}) private title?: string
    @Prop({type: String, default: ''}) private message?: string
    @Prop({type: String, default: 'message.yes'}) private confirmText?: string
    @Prop({type: String, default: 'message.no'}) private cancelText?: string
    @Prop({type: Object, default: () => {return {}}}) private args?: object
  
  created(){
    this.isActive = true
  }

  public onConfirm(yes: boolean): void{
    if(yes){
      this.$emit("onConfirm",this.args);
    }else{
      this.$emit("onConfirm",yes);
    }
  }

}
